import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * Holds the shared refresh-in-progress state for the auth interceptor.
 * Using an injectable service (instead of module-level variables) ensures
 * proper scoping within Angular's DI and simplifies testing.
 */
@Injectable({ providedIn: 'root' })
export class TokenRefreshState {
  isRefreshing = false;
  readonly subject$ = new BehaviorSubject<string | null>(null);
  // Emits when a refresh attempt fails, so requests queued behind it stop
  // waiting instead of hanging forever (subject$ never gets a real token).
  readonly refreshFailed$ = new Subject<void>();
}
